module.exports = __webpack_public_path__ + "static/media/2.7_preview.56643d5b.png";